import { Experiences } from '@/src/experiences'

export default Experiences.Rewards.Screens.PointsLedger.Screen
